import i18next from '@packages/core/i18n';

import logSources from './en/logSources.json';
import telemetry from './en/telemetry.json';
import telemetryAgents from './en/telemetryAgents.json';
import telemetryCloudSensors from './en/telemetryCloudSensors.json';
import telemetryDevices from './en/telemetryDevices.json';
import telemetryScannerConfig from './en/telemetryScannerConfig.json';
import telemetryScanners from './en/telemetryScanners.json';
import telemetryScanSchedules from './en/telemetryScanSchedules.json';
import telemetrySensors from './en/telemetrySensors.json';

i18next.addResourceBundle('en', 'telemetry', telemetry);
i18next.addResourceBundle('en', 'telemetryAgents', telemetryAgents);
i18next.addResourceBundle(
  'en',
  'telemetryScannerConfig',
  telemetryScannerConfig,
);
i18next.addResourceBundle('en', 'telemetryDevices', telemetryDevices);
i18next.addResourceBundle('en', 'telemetryScanners', telemetryScanners);
i18next.addResourceBundle(
  'en',
  'telemetryScanSchedules',
  telemetryScanSchedules,
);
i18next.addResourceBundle('en', 'telemetrySensors', telemetrySensors);
i18next.addResourceBundle('en', 'telemetryCloudSensors', telemetryCloudSensors);
i18next.addResourceBundle('en', 'logSources', logSources);

export default i18next;
